/// <reference path="../_references.ts"/>

module App.Appointments {
	import BottomDrawerService = App.Helpers.BottomDrawerService;
	import BottomDrawerItem = App.Helpers.BottomDrawerItem;

	interface Scope extends ng.IScope {
		bottomDrawerService: BottomDrawerService;
		callNextFunction: (option: BottomDrawerItem) => void;
	}

	export class BottomDrawerDirective {
		public link: (scope: ng.IScope) => void;
		public template: string = '\
				<div class="bdDarkScreen" ng-if="bottomDrawerService.isOpen" ng-click="bottomDrawerService.closeable && bottomDrawerService.close()"></div> \
				<div class="bdContainer" ng-if="bottomDrawerService.isOpen" ng-cloak> \
					<div class="bdContainer-scroll"> \
						<div class="tile-grid">\
							<button class="bdItem tile-cell" ng-repeat="option in bottomDrawerService.options" ng-click="callNextFunction(option)"> \
								<i ng-class="option.icon"></i>\
								<span class="bdItem-text" ng-class="{\'is-padded\': option.icon}">{{ ::option.text }}</span>\
							</button>\
						</div>\
					</div> \
					<button class="bdItem bdItem--cancel" ng-click="bottomDrawerService.close()" ng-if="!bottomDrawerService.hideCancel"> \
						<i class="fas fa-times fa-fw"></i> \
						<span class="bdItem-text">Cancel</span> \
					</button> \
				</div>';
		public scope: boolean = true;
		public restrict: string = 'E';

		constructor($timeout: ng.ITimeoutService, bottomDrawerService: BottomDrawerService) {
			BottomDrawerDirective.prototype.link = (scope: Scope) => {
				scope.bottomDrawerService = bottomDrawerService;
				scope.callNextFunction = callNextFunction;

				function callNextFunction(option: BottomDrawerItem) {
					const timeAnimation = 0.25 * 1000;

					bottomDrawerService.close();

					if (option.fn) {
						if (option.recursive) {
							$timeout(() => {
								option.fn();
							}, timeAnimation + (0.1 * 1000));
						} else {
							option.fn();
						}
					}
				}
			};
		}

		public static Factory() {
			let instance = ($timeout: ng.ITimeoutService, BottomDrawerService: BottomDrawerService) => {
				return new BottomDrawerDirective($timeout, BottomDrawerService);
			};

			instance.$inject = ['$timeout', 'BottomDrawerService'];

			return instance;
		}
	}

	angular.module('helpers.bottomDrawer', [])
		.factory('BottomDrawerService', BottomDrawerService.Factory())
		.directive('bottomDrawer', BottomDrawerDirective.Factory());

}